
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../assets/logo.png'
import { useNavigate } from 'react-router-dom';
import { db, firestore, storage } from '../config';
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
//import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import { RxCross2, RxExternalLink } from "react-icons/rx";
import { active_activityplan_icon, active_goal_icon, active_journal_icon, active_vision_icon, active_week_plan_icon, activities_dashboard_icon, inactive_activityplan_icon, inactive_dashboard_icon, inactive_goal_icon, inactive_habit_icon, inactive_journal_icon, inactive_video_icon, inactive_vision_icon, inactive_week_plan_icon, inactive_win_icon, invite_inactive, logout_icon, settings_inactive } from '../assets/Icon';
import ReactiveButton from 'reactive-button';
import { RxCross1 } from "react-icons/rx";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import ToggleButton from 'react-toggle-button'
import { FiPlus } from "react-icons/fi";
import '../App.css';
import Calendar from 'react-calendar';
import { MdChevronRight } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { connect } from 'react-redux';
import { SetId, SwitchMode } from './redux/actions';
import { encrypt, decrypt } from '../Crypto';
import { LiaStethoscopeSolid } from 'react-icons/lia';
import ReactCardFlip from 'react-card-flip';
import { VscThreeBars } from 'react-icons/vsc';
import Popup from 'reactjs-popup';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

const inactive_color = '#cbb6fe'

const out_link = <RxExternalLink size={24} color='black' />

const userdb = db.ref('userdb');
const suggestdb = db.ref('suggestdb');

const candidate_db = firestore.collection('candidate_db')

const recruiter_db = db.ref('recruiter_db');

const recruiter_active = <FaUserTie color='white' size={22} />
const recruiter_active_non = <FaUserTie color='#B9B9B9' size={22} />


function WeeklyPlan({ items, SetId, SwitchMode }) {

    let curr = new Date().getTime();

    useEffect(() => {
        console.log('Items', items)
        if ((items.logout||items.myid.sub_id==undefined) && items.trial==0) {

            navigate('/')
        }
    }, [items])

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(Math.max(window.innerHeight, 1200));

    useEffect(() => {
        const windowSizeHandler = () => {
            setWidth(window.innerWidth)
            setHeight(Math.max(window.innerHeight, 1200))
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const navigate = useNavigate();

    const [touched1, setTouched1] = useState(false);
    const [password_pop_up, setPasswordPopUp] = useState(true);

    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const [emotion, setEmotion] = useState(false)

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']


    const [delete_pop_up, setDeletePopUp] = useState(false);

    const [date, setDate] = useState(new Date())
    const [shareDate, setShareDate] = useState(null)


    const [action, setAction] = useState('')
    const [action_name, setActionName] = useState('')
    const [completed_list, setCompleteList] = useState(false)
    const [privates, setPrivate] = useState(false)

    const [due_date_share, setDueDateShare] = useState(false)

    const [completed, setCompleted] = useState(false)
    const [outcome, setoutcome] = useState('')
    const [particular, setParticular] = useState(false)

    const [receive, setReceive] = useState(false)
    const [my_open_plan, setMyOpenPlan] = useState([])
    const [my_complete_plan, setMyCompletePlan] = useState([])
    const [steps, setSteps] = useState('')

    function select_from_list_complete(indx) {

        let temp = [...my_complete_plan]
        for (let i = 0; i < temp.length; i++) {
            if (i == indx) {
                temp[i].select = true;
                setActionName(decrypt(temp[i].name_action)); setAction(decrypt(temp[i].action)); setSteps(decrypt(temp[i].steps)); setoutcome((temp[i].outcome));
                setCompleted(true)
            }
            else temp[i].select = false
        }
        setMyCompletePlan([...temp])
    }

    function select_from_list(indx) {

        let temp = [...my_open_plan]
        for (let i = 0; i < temp.length; i++) {
            if (i == indx) {
                temp[i].select = true;
                setActionName(decrypt(temp[i].name_action)); setAction(decrypt(temp[i].action)); setSteps(decrypt(temp[i].steps)); setPrivate(temp[i].private)
            }
            else temp[i].select = false
        }
        top_ref.current?.scrollIntoView({ behavior: 'smooth' })
        setMyOpenPlan([...temp])
    }

    function remove_select() {
        let temp = [...my_open_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { temp[i].select = false; break; }
        }
        setMyOpenPlan([...temp])
    }


    useEffect(() => {
        const plan_db = firestore.collection(`plans`)
        const unsubscribe = plan_db.where('complete', '==', false).where('user_id', '==', items.myid.ID).onSnapshot(snapshot => {
            // console.log('Dats ',snapshot.docs[0].data())
            let arr = snapshot.docs
            for (let i = 0; i < arr.length; i++) {
                arr[i] = arr[i].data()
            }
            console.log('Arr ', arr);

            arr.sort(function (a, b) { return a.ID - b.ID });
            if (arr.length > 0) setMyOpenPlan([...arr])
            else setMyOpenPlan([])
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        const plan_db = firestore.collection(`plans`)
        const unsubscribe = plan_db.where('complete', '==', true).where('user_id', '==', items.myid.ID).onSnapshot(snapshot => {
            // console.log('Dats ',snapshot.docs[0].data())
            let arr = snapshot.docs
            for (let i = 0; i < arr.length; i++) {
                arr[i] = arr[i].data()
            }
            arr.sort(function (a, b) { return b.ID - a.ID });
            if (arr.length > 0) setMyCompletePlan([...arr])
            else setMyCompletePlan([])
        })
        return () => unsubscribe()
    }, [])

    function select_date(day) {
        console.log('Select day ', day)
        let indx = -1;
        for (let i = 0; i < my_open_plan.length; i++) {
            if (my_open_plan[i].start <= new Date(day).getTime() && my_open_plan[i].end >= new Date(day).getTime()) {
                indx = i;
            }
        }
        if (indx > -1) {
            let temp = [...my_open_plan]
            for (let i = 0; i < temp.length; i++) {
                if (i == indx) {
                    temp[i].select = true;
                    setActionName(decrypt(temp[i].name_action)); setAction(decrypt(temp[i].action)); setSteps(decrypt(temp[i].steps));
                }
                else temp[i].select = false
            }
            top_ref.current?.scrollIntoView({ behavior: 'smooth' })
            setMyOpenPlan([...temp])
        }
        else {
            setShareDate(new Date(day));
            if (action_name != '') setActionName('')
            if (action != '') setAction('')
            if (steps != '') setSteps('')
            remove_select()
        }
    }

    function remove_select() {
        let temp = [...my_open_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { temp[i].select = false; break; }
        }
        setMyOpenPlan([...temp])
    }

    function remove_select_complete() {
        let temp = [...my_complete_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { temp[i].select = false; break; }
        }
        setMyCompletePlan([...temp])
    }

    function get_selected() {
        let temp = [...my_open_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { return temp[i].ID; }
        }
        return -1;
    }

    function get_selected_completed() {
        let temp = [...my_complete_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { return temp[i].ID; }
        }
        return -1;
    }

    function get_selected_item() {
        let temp = [...my_open_plan]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].select != undefined && temp[i].select == true) { return temp[i]; }
        }
        return { start: 0, end: 0 };
    }

    async function update_existing() {
        let id = get_selected();
        if (id != -1) {
            const goal_db = firestore.collection(`plans`)
            if (action_name != '' && action != '' && steps != '') {
                let goal_obj = {
                    name_action: encrypt(action_name),
                    steps: encrypt(steps),
                    action: encrypt(action),
                    complete: completed,
                    outcome: encrypt(outcome),
                    private: privates
                }
                await goal_db.doc(String(id)).update(goal_obj)
                toast('Plan has been updated')
                setSteps('');
                setAction('');
                setActionName('')
                setCompleted(false);
                setoutcome('')
            }
            else toast('Empty fields are not accepted !')
        }
        else {
            id = get_selected_completed();
            if (id != -1) {
                const goal_db = firestore.collection(`plans`)
                if (action_name != '' && action != '' && steps != '') {
                    let goal_obj = {
                        name_action: encrypt(action_name),
                        steps: encrypt(steps),
                        action: encrypt(action),
                        complete: completed,
                        outcome: encrypt(outcome),
                        private: privates
                    }
                    await goal_db.doc(String(id)).update(goal_obj)
                    toast('Plan has been updated')
                    setSteps('');
                    setActionName('')
                    setAction('');
                    setCompleted(false);
                    setoutcome('')
                }
                else toast('Empty fields are not accepted !')
            }
        }
    }

    async function make_complete() {
        if (outcome != '') {
            let id = get_selected()
            if (id != -1) {
                const goal_db = firestore.collection(`plans`)
                await goal_db.doc(String(id)).update({ complete: true, outcome: outcome, private: privates })
                toast('This plan is marked as complete')
                setCompleted(false)
                if (action_name != '') setActionName('')
                if (action != '') setAction('')
                if (steps != '') setSteps('')
                setoutcome('')
            }
            else {
                toast('Try again')
            }
        }
        else toast('Empty fields are not accepted')
    }

    async function addGoal() {
        let cur = get_selected()
        let currr = get_selected_completed()

        if (currr == -1) {
            if (cur == -1) {
                if (!ifExist(Number(new Date(shareDate).getTime()))) {
                    if (action_name != '' && action != '' && steps != '' && shareDate != null) {
                        const plan_db = firestore.collection(`plans`)
                        const time = new Date().getTime()
                        let dues = new Date(shareDate);
                        dues.setMilliseconds(0)
                        dues.setHours(0)
                        dues.setSeconds(0)
                        dues.setMinutes(0)
                        let start = dues, end = dues;

                        let curr = dues.getDay()
                        let left = curr - 1;
                        let right = 7 - curr;
                        start = moment(new Date(dues)).subtract(left, 'days')
                        end = moment(new Date(dues)).add(right, 'days')

                        console.log('Start ', new Date(start).getDate(), ' ', 'End ', new Date(end).getDate())

                        let goal_obj = {
                            ID: time,
                            name_action: encrypt(action_name),
                            steps: encrypt(steps),
                            action: encrypt(action),
                            private: privates,
                            complete: false,
                            start: String(new Date(start).getTime()),
                            end: String(new Date(end).getTime()),
                            user_id: items.myid.ID
                        }
                        await plan_db.doc(String(time)).set(goal_obj)
                        toast('Your weekly plan has been published')
                        setActionName(''); setSteps(''); setAction(''); setShareDate(null)
                        console.log('Goal obj ', goal_obj)
                        // goal_db
                    }
                }
                else toast('This week has already planings .')
            }

            else {
                if (!ifExistEdit(Number(new Date(shareDate).getTime()))) {
                    if (action_name != '' && action != '' && steps != '' && shareDate != null) {
                        const plan_db = firestore.collection(`plans`)
                        const time = cur;
                        let dues = new Date(shareDate);
                        dues.setMilliseconds(0)
                        dues.setHours(0)
                        dues.setSeconds(0)
                        dues.setMinutes(0)

                        let start = dues, end = dues;

                        let curr = dues.getDay()
                        let left = curr - 1;
                        let right = 7 - curr;
                        start = moment(new Date(dues)).subtract(left, 'days')
                        end = moment(new Date(dues)).add(right, 'days')

                        let goal_obj = {
                            ID: time,
                            name_action: encrypt(action_name),
                            steps: encrypt(steps),
                            action: encrypt(action),
                            private: privates,
                            complete: false,
                            start: String(new Date(start).getTime()),
                            end: String(new Date(end).getTime()),
                            user_id: items.myid.ID
                        }
                        await plan_db.doc(String(time)).set(goal_obj)
                        toast('Your weekly plan has been updated')
                        setActionName(''); setSteps(''); setAction(''); setShareDate(null)
                        console.log('Goal obj ', goal_obj)
                        // goal_db
                    }
                }
                else toast('This week has already planings .')
            }
        }
        else {
            if (action_name != '' && action != '' && steps != '' && shareDate != null) {
                const plan_db = firestore.collection(`plans`)
                const time = currr;
                let dues = new Date(shareDate);
                dues.setMilliseconds(0)
                dues.setHours(0)
                dues.setSeconds(0)
                dues.setMinutes(0)

                let start = dues, end = dues;

                let curr = dues.getDay()
                let left = curr - 1;
                let right = 7 - curr;
                start = moment(new Date(dues)).subtract(left, 'days')
                end = moment(new Date(dues)).add(right, 'days')

                let goal_obj = {
                    name_action: encrypt(action_name),
                    steps: encrypt(steps),
                    action: encrypt(action),
                    private: privates,
                    complete: false,
                    start: String(new Date(start).getTime()),
                    end: String(new Date(end).getTime()),
                }
                await plan_db.doc(String(time)).update(goal_obj)
                toast('Your weekly plan has been updated')
                setActionName(''); setSteps(''); setAction(''); setShareDate(null); setoutcome('')
                console.log('Goal obj ', goal_obj)
                // goal_db
            }
        }
    }

    useEffect(() => {
        if (shareDate != null) {
            setDueDateShare(false)
            addGoal()
        }
    }, [shareDate])

    function ifExist(time) {

        for (let i = 0; i < my_open_plan.length; i++) {
            console.log(my_open_plan[i].start, ' -> ', my_open_plan[i].end, ' -> ', time)
            if (my_open_plan[i].start <= time && my_open_plan[i].end >= time) return true;
        }
        return false;
    }

    function ifExistEdit(time) {
        for (let i = 0; i < my_open_plan.length; i++) {
            console.log(my_open_plan[i].start, ' -> ', my_open_plan[i].end, ' -> ', time)
            if (my_open_plan[i].start <= time && my_open_plan[i].end >= time && get_selected_item().ID != my_open_plan[i].ID) return true;
        }
        return false;
    }

    async function deletePlan() {
        const goal_db = firestore.collection(`plans`)
        await goal_db.doc(String(delete_pop_up)).delete();
        setDeletePopUp(false)
        toast('Plan has been deleted')
        if (action_name != '') setActionName('')
        if (action != '') setAction('')
        if (steps != '') setSteps('')
        if (outcome != '') setoutcome('')
        setCompleted(false)
        remove_select_complete()
    }

    const [picture, setPicture] = useState(null)
    const [imguri, setImgUri] = useState(null)

    const handleDrop = (e) => {
        e.preventDefault()
        console.log('select ', e.target.files[0])
        let file = e.target.files[0]
        let temp = []

        let reader = new FileReader();
        reader.onloadend = () => {
            setPicture(reader.result)
            setImgUri(file)
        }
        reader.readAsDataURL(file);
        //console.log('All temp ', temp)
    }

    const ref = useRef()

    const openFileInput = () => {
        ref.current.click()
    }

    const uploadImage = async (key, imguri) => {
        const upload = storage.ref(`/users/${key}`).put(imguri)
        await Promise.resolve(upload)
        let uri = await storage.ref(`/users/${key}`).getDownloadURL();
        return uri
    };

    async function updateUri() {
        toast('Please wait')
        let id = items.myid.ID
        let uri = await uploadImage(id, imguri)
        await userdb.child(String(id)).update({ uri: uri })
        let obj = items.myid;
        obj.uri = uri;
        SetId(obj)
        toast('Your photo has been uploaded ')
    }

    useEffect(() => {
        if (imguri != null) {
            updateUri()
        }
    }, [imguri])

    function makingToday() {
        let curr = new Date()
        curr.setHours(0);
        curr.setMinutes(0);
        curr.setMilliseconds(0);
        curr.setSeconds(0)
        return curr.getTime()
    }

    const today = makingToday()

    const weekly = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    function formatting(time) {
        return weekly[new Date(Number(time)).getDay()] + ", " + new Date(Number(time)).getDate() + " " + months[new Date(Number(time)).getMonth()] + " " + new Date(Number(time)).getFullYear()
    }

    const isMobile = width <= 768;

    const getHeight = Math.max(height, 2300)

    const top_ref = useRef()
    const setting_ref = useRef()

    return (
        !isMobile ? <div style={{ backgroundColor: '#f3f9eb', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>
            <div style={{ backgroundColor: '#8455f6', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: 286, textAlign: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#8455f6", width: 276, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <text style={{ color: 'white', marginTop: 30, fontSize: 15, fontFamily: 'Roboto' }}>{decrypt(items.myid.first)} {decrypt(items.myid.second)}</text>
                </div>

                <div onClick={() => navigate('/Dashboard')} style={{ height: 48, cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{inactive_dashboard_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Dashboard</text>
                    </div>
                </div>


                {!items.mode ? <div onClick={() => navigate('/Vision')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_vision_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My vision</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Goals')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_goal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My goals</text>
                    </div>
                </div>

                <div onClick={() => { setActionName(''); setAction(''); setSteps(''); setShareDate(null); remove_select(); setCompleted(false); setPrivate(false) }} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: '#FFFFFF', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{active_week_plan_icon}</div>
                        <text style={{ color: '#8455F6', marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Weekly Action Plan</text>
                    </div>
                </div>

                {!items.mode ? <div onClick={() => navigate('/Journal')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_journal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Journal</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/ActivityPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_activityplan_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Activity Plan</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Wins')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_win_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My Wins</text>
                    </div>
                </div>

                {!items.mode ? <div onClick={() => navigate('/Habit')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_habit_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Habit Tracking</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Videos')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_video_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Videos</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Companies')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{invite_inactive}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Invitations</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Settings')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{settings_inactive}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Settings</text>
                    </div>
                </div>

                <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{logout_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Log Out</text>
                    </div>
                </div>

                <div style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                        <text style={{ color: '#8455F6', marginLeft: 20, fontSize: 15, fontFamily: 'Roboto' }}>Coaching Mode</text>
                        <div style={{ width: 45, display: 'flex', marginLeft: 10 }}>
                            <ToggleButton
                                value={items.mode}
                                inactiveLabel={<text></text>}
                                activeLabel={<text></text>}
                                style={{ background_color: '#41A4C3' }}
                                onToggle={(value) => {
                                    SwitchMode()
                                }}
                                colors={{
                                    activeThumb: {
                                        base: 'white',
                                    },
                                    inactiveThumb: {
                                        base: 'black',
                                    },
                                    active: {
                                        base: '#8455f6',
                                        hover: 'rgb(177, 191, 215)',
                                    },
                                    inactive: {
                                        base: 'gray',
                                        hover: 'gray',
                                    }
                                }} />
                        </div>
                    </div>
                </div>

                <img src={logo} style={{ width: 80, height: 80, alignSelf: 'center', marginTop: 20 }} />

            </div>
            <input id="actual" ref={ref} accept="/*" type="file" onChange={handleDrop} onClick={(event) => {
                event.currentTarget.value = null
            }} hidden={true} />

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 286, width: width - 286, position: 'absolute', top: 0, height: height, backgroundColor: '#1f2327' }}>

                <div style={{ display: 'flex', height: 100, width: width - 286, justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#292e33', boxShadow: '1px 1px 1px 1px #292E33' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'content' }}>
                        <text style={{ marginLeft: 40, fontSize: 40, fontWeight: '600', letterSpacing: 1.01, color: '#8c52ff', textAlign: 'left', fontFamily: 'Barlow Condensed' }}>MY WEEKLY ACTION PLAN</text>
                    </div>
                    {items.myid.uri == undefined && <img onClick={() => openFileInput()} style={{ cursor: 'pointer', width: 60, height: 60, borderRadius: 30, marginRight: 30 }} src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAABhlBMVEUyvqb///8EhKuERi37yMj719ecYUTfLCxv2vEAgqs0wqY+Pj/3tLTJ8vic5fT3k5L70NCQVDkbuqGhWjyfZkpHrZRl4/vcLSyIPCH7ysqFTDQAibL5vr7/3Nzw+vh80sLyx8Uqsqfk9vPI7OVhy7iM18kyNjcZmqlFvqfmtbOx49mc3NBuzr3T8Orb8u46NTUuuaYip6jskJD75eUSkqpizufeGRk3qMfeIyOGQSe27PbPs7PPp6dKuNXC6eFUx7Kr4dd2ZE1tY2QmLzBFSUuS1OFRYWaGv8toi5Pnx8RIUVM1Kypzwa9KxsZZz+DR7vVWw97Bk5rpenolmLvlXV3dCgrjTEzwpaUeoagVlarjUVHYODqokJ6eoK/JWF+QscKoS1pGb5CRVmlbo4tmlnxzhGt/el+MdFlrc1t3XEN8f2Zehm58Uztwa1OxgG6qdV+xlYqtl5eYf3+/pqalx81md3qFd3exkYCJpaqx1dvI0MmYd2eRUCl0MADVxsCpzMGFwbLo5OFW8CDAAAARL0lEQVR4nNWd+0MTxxbHNyGgSSAXtogEycOQYBKegmIiSJCXxmdbtWjtG1v1am1B66PtRf3P77x2d/Y9u3smCd8fqrJkMp+eM+ecmd2dUWLylZ9br29UCuVyq9WqVqvov+XZQmWjvj6X78C3KxLbzpemZgrlqkqlmMV+2ipXZuZKMkllEZbWK5RN8RP+nWq5MlWS1BMZhKV6AXfcl83CWS3UZdgSmjA/VakGhOMpWzPgYxOUML8+G9R2dkqlMAUKCUiI8SLR8ZBw3YIinK9ENJ4VsgIVeUAI8/UWJB+DLMMEHgDCUgXGO+2QygwAY2TC+YIkPspYiOysEQnnyvLwKKM6O99FwvlZyXwUMpodIxCWOsKHESMxhibMVzrERxlnOk5YlxhfHBmV9Y4SzrU6y0cYy+FCTijCTjoozxjKVUMQTnXYQTlEZa4DhPlCt/gIY0U64Vy1m4AIsRV0NAYknOkuH2HckEhY6kIItUstB6rHgxBOdZuNKVjACUDYAx6qSa3LIOxUFSoktQBOmO9yDLVKbYkORkHC+W4T2aS2BOcbYoS9EmPMEsuMQoT13vJQTarQdEOEcKM3AQURBQh7KEtYJZI1/Al7GFCohPMl7NJcUFT+iH6EPW1BLF9H9SHs2SBjyC/ceBP2aJowywfRk3DqOAAiRM/U70XYe6Wam7wKOA/CfLf7LS6vMtyDsNrtfotLbYUh7Kn5oJ885ouuhD2fCM1yT4tuhOvHCxAhuq3duBCWut3hEHKJNi6ErW53N7jUchDCHi+3neVShDsSHpNaxirn2saJUGKqT6XktY0SvyihjEyYWtzff/Lrb0+fPr2K9ezFk/39Uwowr+OdKQdC+ERx6slvowNfIA0MDIw0mcabzYnnz56AYjqlDDthHhhw/78UjWmkj1dzfHz8KqIEkwgh5B3Q1KlfRzk6OyGlbD5/AQTpcCPcRggYR1OnfvvCwudEiCGbzav7IN9pj6c2QsBc/6sNz42QWPLlE4gvteV9KyHcwswpq396EyKNTwAw2tY0LIRwYeaJI58nIWJ8DjAevQnBwowboDchGpAvoiYPa7AxE85DAe67AfoQYjNG/W615EE4C0GH5cbnT9jXfBnRUy3zfRPhHJQJHaOoIGFfcyIqYsmVsAzDp1TdTShAiBCjfb3ZiDwhmAlfuJtQhLCveTXa95vSPk8IluyfRrMhCjcRI+qsMyGYCRUPE4oR9jWjDUV+JHKEUKMQhPD3SB3gR6JBCJYLlVPRCfvGI8bTvAMh2OrTvgefMGHzRaQ+cIWNTgi2OONezgQh7IuYMQwj6oRQq/heuTAIYdRYU7cRQqUKr1wYhHA84oy4bCUESxWjIDZs9kWd8usJQyMsgOAp3plClLA5/ixyP/SVRUYINvPVMsVo+9VISMJm8/dTECuMZkKwhy50wv5c7Q8nRn/CZzDrbuqUiRCsnjEI+3P9tdF/AxNGTfW6tLqGEsLdLuQIEWOu/WpgpEuEWkpUYJ3UTNhPDPnqj5ERb8JmsznxEpyQuSklBFu9sBESyOIaphyxEdL7FxPPX/1ZKxYnwAkLBiHgrQoHQuKu/QhzDYGOvpxAVKgom5h4+fyfd+/+XKslstlsIgFPyNyUEALebXImZJhY/Vms4SxTQpMEQnonihAC3ozxIKQaTjhLBuGMTgjWZm8R0nvCmBBu7usQS3P8HybCrOkPGYRqnhFCPv5kJsy1DzbTW1vT24erOQthdu1we3prK715UMtKI6wzQrgFGivhQXo6TTS9tdnOEVMWEzi8ZGubW9ql9KE0wgIjhGvSXLW1NxkEAZl+vbz6dnM7vb15uDa8Ns1f2ixmpRAqVUoIOQz5yrtNDLiQ3t7eXlggxmJmm96iVxbQlTS9UpRDiCeJCvDD3JwNsQUXbrz/MDQ09OavBc2S05r1Fv56g658eH9jAVtREuEUIQSb/GLphLkDRHLzryGmNxTx7cHB4VsK+Ea7hOmnD7JSCCuEEPQpPWMGTMw0pOvaTcTxOpdD1Qxh/6BfubyL6aXYEK/WKMDPeOmErxHGtgGYyWBTbeZQtshuIvb3BmBmB7vvgRTCah4RggYapfqOTiFG307zGJlMZgcZMd1GhDVsXQ4wk7mO4Slh8x/Yx8tLiBD2rZHl3BFZbRvFhvrAAWYyu8hSq7nhxNo0574YMHNNJ5xYy7YhEVHxrYA+S6r+jdLgESHc5pyUAGI3RQOREl7nAYmbbhPCVVQNHEF2aAMRws1+kY+SUu0dRuQIKSD2RUJ4YBBSQJ2w+Q8u4LKARkTBVAENpbcI4eoI9dL0Bx4Qe+mW2UsZYGYHeekNTPgnKVlvAfaojAgBm1PKpBo9+oKNwzc8YAanvTYirOGUzwNm3rNx2FwFJ2zFFNCHLVsGIU56uzwgDpjbOFsktmm20AEzN3C2GNEJIb1KjSlw97YVNg7725iwPU04dArsidOHJB8eEiNeNrGnV5ENx9tklgEaTPMK7BPBBmHuLUa8rlFc28Zpnc0PScF6TQfE1c7hMCYsYkLgdKHApsMjQvjvwMhAfz+pPncJyA4x09ZBjhBmD7bwpes7BJ3UbOlisa/Z/F+NEEJ2SF1XQN9vwvkQaXV1tY1mT2QScTO9u3vjJgE8zDEbUj9duHljdzd9k0w5ENoaErEhZD5E03wF9OUR9SO/erjKZvh0WrF1yK1iHG5xV6bTa8aqYiLxEbRHGwro3En5ZFogbetLFYjidY4jzOrrG3iBo8YDJj5BdkitKJCLNAoLNZwZN+mkd/OgP2daicomDuil9KbJgOgKbIcKCuw7XGwgGog5PChX2w6ridlsDQ+9RNYMCDsMFWVWAX4X9pZ9DdigM6+XcoulvCArGqQyNKF6ZEfsdye0C9iEwD5KWoxGmIXuETyh+ikS4Sfol64kvCuqOgxFUcL2LfC3yuS8c9/6OxTh3zK29JNDqHoMRndCyLm9IUn7JnhEVHdC6ChKJeudbddwk9Pvb1szPXQiZJJFqFrAEpOaBg2ZEYtyXq9uyRqJH82Eg/+xa89MCDqlMFSWZUVLrBl2IJw0E0oKCWXouYUmS6zJ2Y1oMaGcOIPnFrDzQ0OWWGNDtABKijN4fihtgwhrEM3u8XwWF4VdnOGE5viy9qGxxhoSUQcH97AmbZNCWXEGr9NI27DMsa7J0XxoT/eytmxS14HXS/m2nesa55pGVpzB66Wga94mOdc1zoSS4gxZ84beJIJrXJywLa8TwPeezI07xBoXQllxBj8zBHv/0CzHWONEKGfeRFQGvgdsVrUoRlhcldYFtQB8H9+saiIrQlis1WT1AD9EC/0sBq8q6v6wH2G2PTgokXAK/HkaXpjQhjhsNeCgVMIS+DNRvKrUSF6EBFAiIXkmSl4wrTIMd8I2nezLIyTPtckLphqhyVM5wmxtUDIhezZR3m7IhjM6ERY1wMGatKp0nRBKqkzV1tyyYS47oQE4+FnaCVkl+Oe8dZXxe1V5Y56keepwEStbbOt8NfzOwJSc1RQJz+oTpRZv37lL3/7r54YdEcrvWMaaYpu+RHf3zu1F8C0HCxLet8C6feckEntJ1fBUiskvmBJA9nv4I3duw3ZEf98CciCmlPMXTxJlWNc/exJ+Zr+VoR+6eB50k8ES9HtPKeXsuXjyEuss89NYrOhKWNN2PrjL/rdcSsbPnQWDrBrvroG0l1o8fyGZjMeTX9Lean5qHow8YVHf2oF94kv88eSF8zAjkr6wrgC9JJtKnX0UR/3DOsP6e1lHXHYi3DvSr19mnzhDG0jGH50F2OmUviYL8g5pKrX4MJ5kfKiDV1iHjS1UPjsQftav5tnvXzGaSMYfLkaGNN4hjZYvUHBB3ql3DouNqp2YoaKFsMZt3bzDRi7fRBJ7a7QRSfdSooThCzfknefiJjrcu3vMKHc5xGETYZsDvMt++56tHRR2whuS7aAY9X18m/lo11iwucjvsb3MER5xP89fNMKMtR1iyLDi38cP56apxXMOdFS002NfxSyIlPAz/+Ovxugvu7SUTJ4LF1rZhl+MMJSbPrS5p9EtmhTHVk4sLXPWyhJCfgguL51YGdNSoVtj8Ycheqdt8xlhb5MLrl3CvSKuN3b6xErj65wB1J+Y5Idg7uvGyonThPCiZ2sXQhDGTIQhpsGegPH4PUZ44kRj5f6wYbNJw6bD91ca6DolvOfZWnBE6/40gbcPTp3zBqRJkRAixgffTDKj7S3tMZNOfvOgQa4Swit+zZ0LOBb1nQX1faICLjuf9elRnAQbRojt+HgPGfD+g5XGyoP7yIx7j1ca7Boh9G0teTZYB/X92UPu9ZW64N+lSxwh0srppccUqvF46fSKcQETuocZXRcCGdFhr69SIMJF/x7hYMMTIjKHv1FCzzCjNbcYpIMO+7UF2hwj9VCkS/cshC5ChLZqxqm5hwGMyO2wbxAGmQen3DMh36crgoR+YYa2Fg/ipiUHwiB1jUCcIRIkFGssSKxx3PsyQMLwTRWaLgkRXhIkFE8Y/Ca0/B604glDyEmRzggRnhEkjAv3j996nicUfixD1EkthG6xVJBQ3E1Nx1yE2Qs69SgMISpQT7N8eBqXoyEIHwm6Kb+NsJlQcCQuCvaIJ0T5fjm2/C2pab5Ff+NyvjBhPC6WEs0nQJj3ZBcyYuq8qAk1wsaDx9/RFY3hpa+XaBm+891jrS4VJkyeFzKiyYQWQqGcKFCxmQgR3/cnx04Omb5pCP3ke8oYwIZClZvnvvpCxwSJVGwGYaPxw49jthUNunIx9uMPjUYQQpHKzXpgUPDzLYQqNo2w0fjp5ytj5mV+LLaIP3bl558ajQCEIpWb5fw163kX/lMMsYqNEf6SPMOm+6aVN211DVXcZ5K/BCD0r9xsxwTazpnxTfvCyVCXtrZoLPNrP/Ce2Dsh+qZE27ldNkK/tC9csXHd0tbANT/N2Na4hZvyq9zsZ1rZz3vyCzYBnFSX5pQ0ypU0tw3ekF/l5nAuWeAzu4I7qb62qPmp9g+Bib29KR83teE4nbvmeSdKvGIz9UuzGr4dpd1oEpnY21vyrNy0vYN9CGNlD0Txis3ULz3Y5PUbTUITewd5pETHE2WdCD3uYgSo2MyIWrDZ0W40hQgztCWPyq3qdBSp4xmW7vE0hW/EhJLmpzu6j4aUe+XmfJys8zmk7qtSqdBSzQrfkCug/dw8d0J5D39LlMvJ1S6E8h46lSeXA9bdznSW9+SwJDklCk/C43YksMsg9CKMyXpcUIrUWVcOd0KJpwLDq+qK4UF4rE4fdzl13IfwGB1e7XhctQDhcQmormHUnxD8yVMpsq1bBCE8Doguh8aLEvZ+WnRPhIKEoIdYS5AvoD9hbyM6nhcflLCXHdXfgkKEvRtu/IKMMGGvIvqkiSCEPZr6PRN9QMLYVLdpHORVqgUnRGV4b5lRdVxXi0IYy/fUfNFjPhiasKeyhkiWCEHYQ/FmPUCvgxDG5ntiMKotl1U1AMKeKOEECrUohLH1LptRFcyC4QljJa87U/IBZ0WTRHhCHHC6xaiqQUJMeMJYXuSpGxmAhcAGDEmIRmO184xqK+gIjEKIpxudZVSFZkqQhB121XAOGo0wFpvrWFRVZwXnEcCEeCOETjCqZce71x0h7ETIUVuR+CITEjvKg1Qj2g+EEI3HgiRGValEGH+AhKiSm5HgrGprJnT85AVCiDQ1C2pIVS1Edk8mKEKUIDfKQPMOVSnXQcxHBEeIVNqIHHZUVZ2tB5rh+gmUEClfLyihKdEHC+tw1qOCJsSamykHp0QfKM8AhE6bZBBizW3MtrDLCbGpSqtQl0GHJYsQKz9fr1BOJ1T249ZspT4P7Zm8ZBIy5efW6zOVQrmlvwZQrbbKhcpMfX1OJhrT/wFqHoLnoeUmMAAAAABJRU5ErkJggg=='} />}
                    {items.myid.uri != undefined && <img onClick={() => openFileInput()} src={items.myid.uri} style={{ cursor: 'pointer', height: 60, width: 60, borderRadius: 30, marginRight: 30 }} />}

                </div>

                <div style={{ marginTop: 50, height: height - 200, width: width - 350, alignSelf: 'center', flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>

                    <div style={{ height: height - 200, width: '60%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 10, marginTop: 10, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 26, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> NAME OF YOUR ACTION  </text>
                            <input placeholder=' START TYPING ... ' onChange={(e) => setActionName(e.currentTarget.value)} value={action_name} style={{ paddingLeft: 8, fontSize: 20, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 40, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 10, marginTop: 15, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 26, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> WHAT STEPS DO YOU NEED TO TAKE TO COMPLETE THIS ? </text>
                            <textarea placeholder=' START TYPING ... ' onChange={(e) => setSteps(e.currentTarget.value)} value={steps} style={{ paddingLeft: 8, paddingTop: 8, fontSize: 20, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 160, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 10, marginTop: 15, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 26, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> WHY IS THIS ACTION IMPORTANT ? </text>
                            <textarea placeholder=' START TYPING ... ' onChange={(e) => setAction(e.currentTarget.value)} value={action} style={{ paddingLeft: 8, paddingTop: 8, fontSize: 20, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 160, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ marginLeft: 10, width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>
                            <div style={{ backgroundColor: '#363a3f', width: 260, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto' }}>Action Completed ?</text>
                                <div style={{ width: 45, display: 'flex' }}>
                                    <ToggleButton
                                        value={completed}
                                        inactiveLabel={<text></text>}
                                        activeLabel={<text></text>}
                                        style={{ background_color: '#41A4C3' }}
                                        onToggle={(value) => {
                                            setCompleted(!completed)
                                        }}
                                        colors={{
                                            activeThumb: {
                                                base: 'white',
                                            },
                                            inactiveThumb: {
                                                base: '#363a3f',
                                            },
                                            active: {
                                                base: '#8455f6',
                                                hover: 'rgb(177, 191, 215)',
                                            },
                                            inactive: {
                                                base: '#1f2327',
                                                hover: 'rgb(95,96,98)',
                                            }
                                        }} />
                                </div>
                            </div>

                            <div style={{ backgroundColor: '#363a3f', width: 180, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto' }}>Private</text>
                                <div style={{ width: 45, display: 'flex' }}>
                                    <ToggleButton
                                        value={privates}
                                        inactiveLabel={<text></text>}
                                        activeLabel={<text></text>}
                                        style={{ background_color: '#41A4C3' }}
                                        onToggle={(value) => {
                                            setPrivate(!privates)
                                        }}
                                        colors={{
                                            activeThumb: {
                                                base: 'white',
                                            },
                                            inactiveThumb: {
                                                base: '#363a3f',
                                            },
                                            active: {
                                                base: '#8455f6',
                                                hover: 'rgb(177, 191, 215)',
                                            },
                                            inactive: {
                                                base: '#1f2327',
                                                hover: 'rgb(95,96,98)',
                                            }
                                        }} />
                                </div>
                            </div>

                        </div>

                        <div style={{ marginLeft: 10, width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 120, justifyContent: 'right' }}>

                            </div>

                            <div onClick={() => { if (get_selected_completed() == -1 && completed) make_complete(); else if (get_selected_completed() != -1 && completed) { update_existing() } else { setDueDateShare(true) } }} style={{ cursor: 'pointer', backgroundColor: '#8455F6', width: 300, display: 'flex', alignItems: 'center', flexDirection: 'column', height: 40, justifyContent: 'center', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto' }}>Save</text>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 120, justifyContent: 'right' }}>


                                <div onClick={() => { if (get_selected() != -1) setDeletePopUp(get_selected()); else { setDeletePopUp(get_selected_completed()) } }} style={{ cursor: 'pointer', opacity: (get_selected() == -1 && get_selected_completed() == -1) ? 0.6 : 1, width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FF4747', borderRadius: 4 }}>
                                    <RiDeleteBinLine color='white' size={18} />
                                </div>
                            </div>
                        </div>

                    </div>

                    <ReactCardFlip flipDirection='horizontal' isFlipped={!completed} containerStyle={{ height: height - 200, width: '35%', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                        <div style={{ height: height - 200, width: '100%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>

                            <div style={{ width: '95%', alignSelf: 'center', height: 200, backgroundColor: '#1f2327', marginTop: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <text style={{ width: '94%', textAlign: 'left', fontSize: 26, fontWeight: '600', color: '#8c52ff', fontFamily: 'Barlow Condensed' }}>WHAT WAS THE OUTCOME ?</text>
                                <textarea placeholder=' START TYPING ... ' onChange={(e) => setoutcome(e.currentTarget.value)} value={outcome} style={{ fontSize: 20, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '94%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 180, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                            </div>

                        </div>
                        <div style={{ height: height - 200, width: '100%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>

                            <div className='calendar-container'>
                                <Calendar onChange={(e) => select_date(e)} value={date} tileContent={({ date, view }) => {

                                    if (my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today < x.end) && (x.select == undefined || x.select == false) && !(items.mode && x.private != undefined && x.private))) {
                                        return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today < x.end) && (x.select !== undefined && x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today > x.end) && (x.select !== undefined && x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#FF0000', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today > x.end) && (x.select == undefined || x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#FF0000', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)

                                    else if (moment(new Date(date)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) {
                                        return (<div style={{ backgroundColor: '#8455F6', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }

                                }} />
                            </div>

                            <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                            <text style={{ textAlign: 'center', fontWeight: '500', fontFamily: 'Barlow Condensed', color: '#8c52ff', marginTop: 5, fontSize: 22 }}>WEEKLY ACTION PLAN ITEMS</text>

                            <div style={{ width: '95%', alignSelf: 'center', display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: 5 }}>

                                {my_open_plan.map((item, id) => items.mode ? (item.private != undefined && item.private) ? null : <div onClick={() => select_from_list(id)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 54, backgroundColor: today > item.end ? '#ffcccc' : '#1f2327', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                                    <div style={{ height: 20, width: 20, borderRadius: 13, borderWidth: 2, borderColor: '#5E5E5E', borderStyle: 'solid', marginLeft: 20 }} />
                                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'left', marginLeft: 10 }}>
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#FF0000', fontFamily: 'Barlow Condensed' }}>{id + 1} Task {`( ${decrypt(item.name_action)} )`}</text> : <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#5E5E5E', fontFamily: 'Roboto' }}>{id + 1} Task </text>}
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 13, fontWeight: '400', color: '#FF0000', fontFamily: 'Barlow Condensed', marginTop: 4 }}>{formatting(item.end)}</text> : <text style={{ textAlign: 'left', fontSize: 12, fontWeight: '400', color: '#5E5E5E', fontFamily: 'Roboto', marginTop: 4 }}>{formatting(item.end)}</text>}
                                    </div>
                                </div> : <div onClick={() => select_from_list(id)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 54, backgroundColor: today > item.end ? '#ffcccc' : '#1f2327', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                                    <div style={{ height: 20, width: 20, borderRadius: 13, borderWidth: 2, borderColor: '#5E5E5E', borderStyle: 'solid', marginLeft: 20 }} />
                                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'left', marginLeft: 10 }}>
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#FF0000', fontFamily: 'Barlow Condensed' }}>{id + 1} Task {`( ${decrypt(item.name_action)} )`}</text> : <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#5E5E5E', fontFamily: 'Roboto' }}>{id + 1} Task </text>}
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 13, fontWeight: '400', color: '#FF0000', fontFamily: 'Barlow Condensed', marginTop: 4 }}>{formatting(item.end)}</text> : <text style={{ textAlign: 'left', fontSize: 12, fontWeight: '400', color: '#5E5E5E', fontFamily: 'Roboto', marginTop: 4 }}>{formatting(item.end)}</text>}
                                    </div>
                                </div>)}
                            </div>

                            <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                            <div onClick={() => setCompleteList(true)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 77, backgroundColor: '#1f2327', marginTop: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <text style={{ textAlign: 'center', fontSize: 22, fontWeight: '500', color: '#8c52ff', fontFamily: 'Barlow Condensed', marginLeft: 5, marginTop: 6 }}>PREVIOUS WEEKS COMPLETE ACTION ITEMS</text>
                                <text style={{ fontWeight: '600', fontSize: 28, color: 'white', fontFamily: 'Barlow Condensed' }}>{my_complete_plan.length}</text>
                            </div>

                        </div>
                    </ReactCardFlip>

                </div>

                {completed_list ? <div style={{ boxShadow: '1px 1px 1px 1px #131517', borderWidth: 1, borderColor: '#292e33', borderStyle: 'solid', marginTop: -500, display: 'flex', width: 400, height: 500, borderRadius: 4, flexDirection: 'column', alignSelf: 'end', backgroundColor: '#1f2327', zIndex: 100, marginRight: '36%' }}>

                    <div onClick={() => setCompleteList(false)} style={{ alignSelf: 'flex-end', cursor: 'pointer', padding: 3 }}>
                        <RxCross2 color='white' size={20} />
                    </div>

                    <div style={{ backgroundColor: '#292e33', width: 350, alignSelf: 'center', height: 45, display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}>
                        <text style={{ textAlign: 'center', fontWeight: '600', fontSize: 16, color: 'white', fontFamily: 'Roboto' }}>{my_complete_plan.length} PREVIOUS WEEKS COMPLETE ACTION ITEMS</text>
                    </div>

                    <div style={{ width: 350, alignSelf: 'center', display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: 5, height: 400, alignItems: 'center', overflowX: 'hidden' }}>
                        {my_complete_plan.map((item, id) => (item.private != undefined && item.private && items.mode) ? null : <div onClick={() => { setParticular(true); select_from_list_complete(id); setPrivate(item.private) }} style={{ cursor: 'pointer', flexDirection: 'row', width: '90%', alignSelf: 'center', height: 45, backgroundColor: '#292e33', marginTop: 3, marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                            <text style={{ textAlign: 'center', fontSize: 12, fontWeight: '400', color: 'white', fontFamily: 'Roboto' }}>{decrypt(item.name_action)}</text>
                            <IoMdCheckmarkCircle color='#3AB549' size={23} />
                        </div>)}
                    </div>

                </div> : null}



            </div>

            <wc-toast></wc-toast>

            <ReactModal
                isOpen={due_date_share}
                style={{ overlay: { backdropFilter: "blur(1px)", backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', height: height, width: width, justifyContent: 'right' }, content: { backgroundColor: '#1f2327', position: 'absolute', left: (width - 650) / 2, top: 100, display: 'flex', width: 650, alignSelf: 'center', flexDirection: 'column', borderRadius: 8, height: 350, borderColor: '#E7E7E7', borderStyle: 'solid', borderWidth: 1 } }}
                onRequestClose={() => setDueDateShare(false)}
                closeTimeoutMS={100}
                contentLabel={"DELETE CATEGORY"}
                ariaHideApp={true}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
                role={"dialog"}
                aria={{
                    labelledby: "heading",
                    describedby: "full_description"
                }}
            >

                <div style={{ display: 'flex', width: 650, height: 400, flexDirection: 'column', backgroundColor: '#1f2327', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: '95%', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', fontFamily: 'Barlow Condensed' }}>The action plan to be completed by ...</text>
                        <div onClick={() => setDueDateShare(false)} style={{ width: '10%', alignSelf: 'end', cursor: 'pointer' }}>
                            <IoMdClose color='#41A4C3' size={25} />
                        </div>
                    </div>
                    <wc-toast></wc-toast>
                    <div style={{ display: 'flex', minWidth: 400, width: 400, alignItems: 'center', alignSelf: 'center', justifyContent: 'center', flexDirection: 'column', height: 250, marginTop: 40, marginLeft: 2 }}>
                        <div className='calendar-container'>
                            <Calendar onChange={setShareDate} value={shareDate} tileContent={({ date, view }) => {
                                if (get_selected_item().start <= new Date(date).getTime() && get_selected_item().end >= new Date(date).getTime()) {
                                    return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                }
                            }} />
                        </div>
                    </div>
                </div>

            </ReactModal >

            <ReactModal
                isOpen={delete_pop_up}
                contentLabel="Inline Styles Modal Example"
                style={{
                    overlay: {
                        backgroundColor: 'transparent',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    content: {
                        color: 'lightsteelblue',
                        width: 400,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        height: 200,
                        marginLeft: (window.innerWidth - 600) / 2,
                        backgroundColor: '#131517',
                        display: 'flex'
                    }
                }}
            >

                <div style={{ alignSelf: 'center', justifyContent: 'center', alignItems: 'center', width: 400, alignContent: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center' }}>
                        <text style={{ textAlign: 'center', fontFamily: 'Roboto', fontWeight: '500', fontSize: 20, color: 'white' }}>  Are you sure you want to delete this ?</text>
                    </div>
                    <div style={{ marginTop: 20, alignSelf: 'center', justifyContent: 'space-around', flexDirection: 'row', display: 'flex', width: 280, alignItems: 'center' }}>

                        <div onClick={() => deletePlan()} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: 'red', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>Yes</text>
                        </div>

                        <div onClick={() => setDeletePopUp(false)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: "#8455f6", borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>No</text>
                        </div>

                    </div>
                </div>

            </ReactModal>

        </div> : <div style={{ backgroundColor: '#f3f9eb', display: 'flex', flexDirection: 'column', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>

            <input id="actual" ref={ref} accept="/*" type="file" onChange={handleDrop} onClick={(event) => {
                event.currentTarget.value = null
            }} hidden={true} />

            <div style={{ display: 'flex', flexDirection: 'column', width: width, height: getHeight, backgroundColor: '#1f2327' }}>

                <div ref={top_ref} style={{ display: 'flex', height: 150, width: width, justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#292e33', boxShadow: '1px 1px 1px 1px #292E33' }}>

                    <Popup
                        trigger={<div className="menu-item"><VscThreeBars color='white' size={35} style={{ marginLeft: 25 }} /></div>}
                        position="right top"
                        on="click"
                        closeOnDocumentClick={false}
                        mouseLeaveDelay={300}
                        mouseEnterDelay={30}
                        contentStyle={{ padding: '0px', border: 'none', marginRight: 50, width: 280, display: 'flex', borderStyle: 'solid', borderWidth: 1, borderColor: 'white' }}
                        arrow={true}
                        overlayStyle={{ marginLeft: -20 }}
                        onOpen={() => setting_ref.current.scrollIntoView({ behavior: 'smooth' })}

                    >

                        <div style={{ backgroundColor: '#8455f6', display: 'flex', flexDirection: 'column', height: 500, width: 280, textAlign: 'center', overflowY: 'scroll' }}>
                            <div ref={setting_ref} style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#8455f6", width: 276, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                                <text style={{ color: 'white', marginTop: 30, fontSize: 15, fontFamily: 'Roboto' }}>{decrypt(items.myid.first)} {decrypt(items.myid.second)}</text>
                            </div>

                            <div onClick={() => navigate('/Dashboard')} style={{ height: 48, cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                                <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 19 }}>{inactive_dashboard_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Dashboard</text>
                                </div>
                            </div>


                            {!items.mode ? <div onClick={() => navigate('/Vision')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_vision_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My vision</text>
                                </div>
                            </div> : null}

                            <div onClick={() => navigate('/Goals')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_goal_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My goals</text>
                                </div>
                            </div>

                            <div onClick={() => { setActionName(''); setAction(''); setSteps(''); setShareDate(null); remove_select(); setCompleted(false); setPrivate(false) }} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                                <div style={{ backgroundColor: '#FFFFFF', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 19 }}>{active_week_plan_icon}</div>
                                    <text style={{ color: '#8455F6', marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Weekly Action Plan</text>
                                </div>
                            </div>

                            {!items.mode ? <div onClick={() => navigate('/Journal')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_journal_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Journal</text>
                                </div>
                            </div> : null}

                            <div onClick={() => navigate('/ActivityPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_activityplan_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Activity Plan</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/Wins')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_win_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My Wins</text>
                                </div>
                            </div>

                            {!items.mode ? <div onClick={() => navigate('/Habit')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_habit_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Habit Tracking</text>
                                </div>
                            </div> : null}

                            <div onClick={() => navigate('/Videos')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_video_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Videos</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/Companies')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{invite_inactive}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Invitations</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{logout_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Log Out</text>
                                </div>
                            </div>

                            <div style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                                    <text style={{ color: '#8455F6', marginLeft: 20, fontSize: 15, fontFamily: 'Roboto' }}>Coaching Mode</text>
                                    <div style={{ width: 45, display: 'flex', marginLeft: 10 }}>
                                        <ToggleButton
                                            value={items.mode}
                                            inactiveLabel={<text></text>}
                                            activeLabel={<text></text>}
                                            style={{ background_color: '#41A4C3' }}
                                            onToggle={(value) => {
                                                SwitchMode()
                                            }}
                                            colors={{
                                                activeThumb: {
                                                    base: 'white',
                                                },
                                                inactiveThumb: {
                                                    base: 'black',
                                                },
                                                active: {
                                                    base: '#8455f6',
                                                    hover: 'rgb(177, 191, 215)',
                                                },
                                                inactive: {
                                                    base: 'gray',
                                                    hover: 'gray',
                                                }
                                            }} />
                                    </div>
                                </div>
                            </div>

                            <img src={logo} style={{ width: 80, height: 80, alignSelf: 'center', marginTop: 20 }} />

                        </div>
                    </Popup>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'content' }}>
                        <text style={{ marginLeft: 40, fontSize: 40, fontWeight: '600', letterSpacing: 1.01, color: '#8c52ff', textAlign: 'left', fontFamily: 'Barlow Condensed' }}>MY WEEKLY ACTION PLAN</text>
                    </div>
                    {items.myid.uri == undefined && <img onClick={() => openFileInput()} style={{ cursor: 'pointer', width: 60, height: 60, borderRadius: 30, marginRight: 30 }} src={'data:image/png;base64,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'} />}
                    {items.myid.uri != undefined && <img onClick={() => openFileInput()} src={items.myid.uri} style={{ cursor: 'pointer', height: 60, width: 60, borderRadius: 30, marginRight: 30 }} />}

                </div>

                <div style={{ marginTop: 50, height: getHeight - 500, width: width, alignSelf: 'center', flexDirection: 'column', display: 'flex' }}>

                    <div style={{ height: 790, width: 0.97 * width, backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 10, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 24, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> NAME OF YOUR ACTION  </text>
                            <input placeholder=' START TYPING ... ' onChange={(e) => setActionName(e.currentTarget.value)} value={action_name} style={{ fontSize: 18, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 40, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 24, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> WHAT STEPS DO YOU NEED TO TAKE TO COMPLETE THIS ? </text>
                            <textarea placeholder=' START TYPING ... ' onChange={(e) => setSteps(e.currentTarget.value)} value={steps} style={{ fontSize: 18, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 160, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15, backgroundColor: '#1f2327', borderRadius: 4 }}>
                            <text style={{ fontWeight: '600', fontFamily: 'Roboto', textAlign: 'left', color: '#8c52ff', fontSize: 24, fontFamily: 'Barlow Condensed', marginLeft: 8, marginTop: 8 }}> WHY IS THIS ACTION IMPORTANT ? </text>
                            <textarea placeholder=' START TYPING ... ' onChange={(e) => setAction(e.currentTarget.value)} value={action} style={{ fontSize: 18, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '98%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 160, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                        </div>

                        <div style={{ width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>
                            <div style={{ backgroundColor: '#363a3f', width: 190, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 14, color: 'white', fontFamily: 'Roboto' }}>Action Completed ?</text>
                                <div style={{ width: 45, display: 'flex' }}>
                                    <ToggleButton
                                        value={completed}
                                        inactiveLabel={<text></text>}
                                        activeLabel={<text></text>}
                                        style={{ background_color: '#41A4C3' }}
                                        onToggle={(value) => {
                                            setCompleted(!completed)
                                        }}
                                        colors={{
                                            activeThumb: {
                                                base: 'white',
                                            },
                                            inactiveThumb: {
                                                base: '#363a3f',
                                            },
                                            active: {
                                                base: '#8455f6',
                                                hover: 'rgb(177, 191, 215)',
                                            },
                                            inactive: {
                                                base: '#1f2327',
                                                hover: 'rgb(95,96,98)',
                                            }
                                        }} />
                                </div>
                            </div>

                            <div style={{ backgroundColor: '#363a3f', width: 140, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 14, color: 'white', fontFamily: 'Roboto' }}>Private</text>
                                <div style={{ width: 45, display: 'flex' }}>
                                    <ToggleButton
                                        value={privates}
                                        inactiveLabel={<text></text>}
                                        activeLabel={<text></text>}
                                        style={{ background_color: '#41A4C3' }}
                                        onToggle={(value) => {
                                            setPrivate(!privates)
                                        }}
                                        colors={{
                                            activeThumb: {
                                                base: 'white',
                                            },
                                            inactiveThumb: {
                                                base: '#363a3f',
                                            },
                                            active: {
                                                base: '#8455f6',
                                                hover: 'rgb(177, 191, 215)',
                                            },
                                            inactive: {
                                                base: '#1f2327',
                                                hover: 'rgb(95,96,98)',
                                            }
                                        }} />
                                </div>
                            </div>

                        </div>

                        <div style={{ width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 120, justifyContent: 'right' }}>

                            </div>

                            <div onClick={() => { if (get_selected_completed() == -1 && completed) make_complete(); else if (get_selected_completed() != -1 && completed) { update_existing() } else { setDueDateShare(true) } }} style={{ cursor: 'pointer', backgroundColor: '#8455F6', width: 300, display: 'flex', alignItems: 'center', flexDirection: 'column', height: 40, justifyContent: 'center', borderRadius: 4 }}>
                                <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto' }}>Save</text>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 120, justifyContent: 'right' }}>


                                <div onClick={() => { if (get_selected() != -1) setDeletePopUp(get_selected()); else { setDeletePopUp(get_selected_completed()) } }} style={{ cursor: 'pointer', opacity: (get_selected() == -1 && get_selected_completed() == -1) ? 0.6 : 1, width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FF4747', borderRadius: 4 }}>
                                    <RiDeleteBinLine color='white' size={18} />
                                </div>
                            </div>
                        </div>

                    </div>

                    <ReactCardFlip flipDirection='horizontal' isFlipped={!completed} containerStyle={{ height: 600, width: 0.97 * width, alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center', marginTop: 40 }}>
                        <div style={{ height: 600, width: '100%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>

                            <div style={{ width: '95%', alignSelf: 'center', height: 200, backgroundColor: '#1f2327', marginTop: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <text style={{ width: '94%', textAlign: 'left', fontSize: 26, fontWeight: '600', color: '#8c52ff', fontFamily: 'Barlow Condensed' }}>WHAT WAS THE OUTCOME ?</text>
                                <textarea placeholder=' START TYPING ... ' onChange={(e) => setoutcome(e.currentTarget.value)} value={outcome} style={{ fontSize: 20, color: '#e3e5e8', fontFamily: 'Barlow Condensed', width: '94%', alignSelf: 'center', borderStyle: 'none', outline: 'none', height: 180, padding: 4, backgroundColor: '#1f2327', borderRadius: 4, marginTop: 15, fontWeight: '900' }} />
                            </div>

                        </div>
                        <div style={{ height: 600, width: '100%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center', marginTop: 15 }}>

                            <div className='calendar-container'>
                                <Calendar onChange={(e) => select_date(e)} value={date} tileContent={({ date, view }) => {

                                    if (my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today < x.end) && (x.select == undefined || x.select == false) && !(items.mode && x.private != undefined && x.private))) {
                                        return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today < x.end) && (x.select !== undefined && x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today > x.end) && (x.select !== undefined && x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#FF0000', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (today > x.end) && (x.select == undefined || x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#FF0000', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)

                                    else if (moment(new Date(date)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) {
                                        return (<div style={{ backgroundColor: '#8455F6', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }

                                }} />
                            </div>

                            <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                            <text style={{ textAlign: 'center', fontWeight: '500', fontFamily: 'Barlow Condensed', color: '#8c52ff', marginTop: 5, fontSize: 22 }}>WEEKLY ACTION PLAN ITEMS</text>

                            <div style={{ width: '95%', alignSelf: 'center', display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: 5 }}>

                                {my_open_plan.map((item, id) => items.mode ? (item.private != undefined && item.private) ? null : <div onClick={() => select_from_list(id)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 54, backgroundColor: today > item.end ? '#ffcccc' : '#1f2327', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                                    <div style={{ height: 20, width: 20, borderRadius: 13, borderWidth: 2, borderColor: '#5E5E5E', borderStyle: 'solid', marginLeft: 20 }} />
                                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'left', marginLeft: 10 }}>
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#FF0000', fontFamily: 'Barlow Condensed' }}>{id + 1} Task {`( ${decrypt(item.name_action)} )`}</text> : <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#5E5E5E', fontFamily: 'Roboto' }}>{id + 1} Task </text>}
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 13, fontWeight: '400', color: '#FF0000', fontFamily: 'Barlow Condensed', marginTop: 4 }}>{formatting(item.end)}</text> : <text style={{ textAlign: 'left', fontSize: 12, fontWeight: '400', color: '#5E5E5E', fontFamily: 'Roboto', marginTop: 4 }}>{formatting(item.end)}</text>}
                                    </div>
                                </div> : <div onClick={() => select_from_list(id)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 54, backgroundColor: today > item.end ? '#ffcccc' : '#1f2327', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                                    <div style={{ height: 20, width: 20, borderRadius: 13, borderWidth: 2, borderColor: '#5E5E5E', borderStyle: 'solid', marginLeft: 20 }} />
                                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'left', marginLeft: 10 }}>
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#FF0000', fontFamily: 'Barlow Condensed' }}>{id + 1} Task {`( ${decrypt(item.name_action)} )`}</text> : <text style={{ textAlign: 'left', fontSize: 15, fontWeight: '500', color: '#5E5E5E', fontFamily: 'Roboto' }}>{id + 1} Task </text>}
                                        {today > item.end ? <text style={{ textAlign: 'left', fontSize: 13, fontWeight: '400', color: '#FF0000', fontFamily: 'Barlow Condensed', marginTop: 4 }}>{formatting(item.end)}</text> : <text style={{ textAlign: 'left', fontSize: 12, fontWeight: '400', color: '#5E5E5E', fontFamily: 'Roboto', marginTop: 4 }}>{formatting(item.end)}</text>}
                                    </div>
                                </div>)}
                            </div>

                            <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                            <div onClick={() => setCompleteList(true)} style={{ cursor: 'pointer', width: '95%', alignSelf: 'center', height: 77, backgroundColor: '#1f2327', marginTop: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <text style={{ textAlign: 'center', fontSize: 22, fontWeight: '500', color: '#8c52ff', fontFamily: 'Barlow Condensed', marginLeft: 5, marginTop: 6 }}>PREVIOUS WEEKS COMPLETE ACTION ITEMS</text>
                                <text style={{ fontWeight: '600', fontSize: 28, color: 'white', fontFamily: 'Barlow Condensed' }}>{my_complete_plan.length}</text>
                            </div>

                        </div>
                    </ReactCardFlip>

                </div>

                <Modal open={completed_list != false}
                    onClose={() => setCompleteList(false)}
                    center
                    styles={{
                        modal: {
                            backgroundColor: '#1f2327'
                        },
                        closeButton: { backgroundColor: 'white', borderRadius: 15 }
                    }}
                >

                    <div style={{ backgroundColor: '#292e33', width: 300, alignSelf: 'center', height: 45, display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 30 }}>
                        <text style={{ textAlign: 'center', fontWeight: '600', fontSize: 16, color: 'white', fontFamily: 'Roboto' }}>{my_complete_plan.length} PREVIOUS WEEKS COMPLETE ACTION ITEMS</text>
                    </div>

                    <div style={{ width: 300, alignSelf: 'center', display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: 5, height: 300, alignItems: 'center', overflowX: 'hidden' }}>
                        {my_complete_plan.map((item, id) => (item.private != undefined && item.private && items.mode) ? null : <div onClick={() => { setParticular(true); select_from_list_complete(id); setPrivate(item.private) }} style={{ cursor: 'pointer', flexDirection: 'row', width: '90%', alignSelf: 'center', height: 45, backgroundColor: '#292e33', marginTop: 3, marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                            <text style={{ textAlign: 'center', fontSize: 12, fontWeight: '400', color: 'white', fontFamily: 'Roboto' }}>{decrypt(item.name_action)}</text>
                            <IoMdCheckmarkCircle color='#3AB549' size={23} />
                        </div>)}
                    </div>

                </Modal>




            </div>

            <wc-toast></wc-toast>

            <ReactModal
                isOpen={!isMobile && due_date_share}
                style={{ overlay: { backdropFilter: "blur(1px)", backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', height: height, width: width, justifyContent: 'right' }, content: { backgroundColor: '#1f2327', position: 'absolute', left: (width - 650) / 2, top: 100, display: 'flex', width: 650, alignSelf: 'center', flexDirection: 'column', borderRadius: 8, height: 350, borderColor: '#E7E7E7', borderStyle: 'solid', borderWidth: 1 } }}
                onRequestClose={() => setDueDateShare(false)}
                closeTimeoutMS={100}
                contentLabel={"DELETE CATEGORY"}
                ariaHideApp={true}
                shouldFocusAfterRender={true}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                shouldReturnFocusAfterClose={true}
                preventScroll={true}
                role={"dialog"}
                aria={{
                    labelledby: "heading",
                    describedby: "full_description"
                }}
            >

                <div style={{ display: 'flex', width: 650, height: 400, flexDirection: 'column', backgroundColor: '#1f2327', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: '95%', justifyContent: 'space-between' }}>
                        <text style={{ color: 'white', fontFamily: 'Barlow Condensed' }}>The action plan to be completed by ...</text>
                        <div onClick={() => setDueDateShare(false)} style={{ width: '10%', alignSelf: 'end', cursor: 'pointer' }}>
                            <IoMdClose color='#41A4C3' size={25} />
                        </div>
                    </div>
                    <wc-toast></wc-toast>
                    <div style={{ display: 'flex', minWidth: 400, width: 400, alignItems: 'center', alignSelf: 'center', justifyContent: 'center', flexDirection: 'column', height: 250, marginTop: 40, marginLeft: 2 }}>
                        <div className='calendar-container'>
                            <Calendar onChange={setShareDate} value={shareDate} tileContent={({ date, view }) => {
                                if (get_selected_item().start <= new Date(date).getTime() && get_selected_item().end >= new Date(date).getTime()) {
                                    return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                }
                            }} />
                        </div>
                    </div>
                </div>

            </ReactModal >

            <ReactModal
                isOpen={!isMobile && delete_pop_up}
                contentLabel="Inline Styles Modal Example"
                style={{
                    overlay: {
                        backgroundColor: 'transparent',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    content: {
                        color: 'lightsteelblue',
                        width: 400,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        height: 200,
                        marginLeft: (window.innerWidth - 600) / 2,
                        backgroundColor: '#131517',
                        display: 'flex'
                    }
                }}
            >

                <div style={{ alignSelf: 'center', justifyContent: 'center', alignItems: 'center', width: 400, alignContent: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center' }}>
                        <text style={{ textAlign: 'center', fontFamily: 'Roboto', fontWeight: '500', fontSize: 20, color: 'white' }}>  Are you sure you want to delete this ?</text>
                    </div>
                    <div style={{ marginTop: 20, alignSelf: 'center', justifyContent: 'space-around', flexDirection: 'row', display: 'flex', width: 280, alignItems: 'center' }}>

                        <div onClick={() => deletePlan()} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: 'red', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>Yes</text>
                        </div>

                        <div onClick={() => setDeletePopUp(false)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: "#8455f6", borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>No</text>
                        </div>

                    </div>
                </div>

            </ReactModal>

            <Modal open={isMobile && delete_pop_up}
                onClose={() => setDeletePopUp(false)}
                center
                styles={{
                    modal: {
                        backgroundColor: '#1F2327',
                    },
                    closeButton: { backgroundColor: 'white', borderRadius: 15 }
                }}
            >
                <div style={{ alignSelf: 'center', justifyContent: 'center', alignItems: 'center', width: 300, alignContent: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center', marginTop: 45 }}>
                        <text style={{ textAlign: 'center', fontFamily: 'Roboto', fontWeight: '500', fontSize: 20, color: 'white' }}>  Are you sure you want to delete this ?</text>
                    </div>
                    <div style={{ marginTop: 20, alignSelf: 'center', justifyContent: 'space-around', flexDirection: 'row', display: 'flex', width: 280, alignItems: 'center' }}>

                        <div onClick={() => deletePlan()} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: 'red', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>Yes</text>
                        </div>

                        <div onClick={() => setDeletePopUp(false)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: "#8455f6", borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>No</text>
                        </div>

                    </div>
                </div>
            </Modal>

            <Modal open={isMobile && due_date_share}
                onClose={() => setDueDateShare(false)}
                center
                styles={{
                    modal: {
                        backgroundColor: '#1F2327',
                    },
                    closeButton: { backgroundColor: 'white', borderRadius: 15 }
                }}
            >
                <div style={{ display: 'flex', width: 300, height: 400, flexDirection: 'column', backgroundColor: '#1f2327', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: '95%', justifyContent: 'space-between',marginTop:45 }}>
                        <text style={{ color: 'white', fontFamily: 'Barlow Condensed' }}>The action plan to be completed by ...</text>
                       <text></text>
                    </div>
                    <wc-toast></wc-toast>
                    <div style={{ display: 'flex', minWidth: 300, width: 300, alignItems: 'center', alignSelf: 'center', justifyContent: 'center', flexDirection: 'column', height: 250, marginTop: 40, marginLeft: 2 }}>
                        <div className='calendar-container'>
                            <Calendar onChange={setShareDate} value={shareDate} tileContent={({ date, view }) => {
                                if (get_selected_item().start <= new Date(date).getTime() && get_selected_item().end >= new Date(date).getTime()) {
                                    return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                }
                            }} />
                        </div>
                    </div>
                </div>

            </Modal>

        </div>
    );
}

const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId, SwitchMode })(WeeklyPlan)

/*
 {completed_list ? <div style={{ boxShadow: '1px 1px 1px 1px #131517', borderWidth: 1, borderColor: '#292e33', borderStyle: 'solid', position: 'absolute', bottom: 20, display: 'flex', width: 300, height: 400, borderRadius: 4, flexDirection: 'column', alignSelf: 'end', backgroundColor: '#1f2327', zIndex: 100, marginRight: (width - 300) / 2 }}>



                    <div style={{ backgroundColor: '#292e33', width: 300, alignSelf: 'center', height: 45, display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}>
                        <text style={{ textAlign: 'center', fontWeight: '600', fontSize: 16, color: 'white', fontFamily: 'Roboto' }}>{my_complete_plan.length} PREVIOUS WEEKS COMPLETE ACTION ITEMS</text>
                    </div>

                    <div style={{ width: 300, alignSelf: 'center', display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: 5, height: 300, alignItems: 'center', overflowX: 'hidden' }}>
                        {my_complete_plan.map((item, id) => (item.private != undefined && item.private && items.mode) ? null : <div onClick={() => { setParticular(true); select_from_list_complete(id); setPrivate(item.private) }} style={{ cursor: 'pointer', flexDirection: 'row', width: '90%', alignSelf: 'center', height: 45, backgroundColor: '#292e33', marginTop: 3, marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderStyle: 'solid', borderColor: (item.select !== undefined && item.select == true) ? 'white' : 'transparent', borderWidth: 1, borderRadius: 4 }}>
                            <text style={{ textAlign: 'center', fontSize: 12, fontWeight: '400', color: 'white', fontFamily: 'Roboto' }}>{decrypt(item.name_action)}</text>
                            <IoMdCheckmarkCircle color='#3AB549' size={23} />
                        </div>)}
                    </div>

                </div> : null}

*/

/*
 if (my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (x.select == undefined || x.select == false) && !(items.mode && x.private != undefined && x.private))) {
                                        return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                    else if ((my_open_plan.find(x => x.start <= new Date(date).getTime() && x.end >= new Date(date).getTime() && (x.select !== undefined && x.select == true) && !(items.mode && x.private != undefined && x.private)))) return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                               


*/


/*

 <div style={{ backgroundColor: '#8455f6', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: 286, textAlign: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#8455f6", width: 276, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <text style={{ color: 'white', marginTop: 30, fontSize: 15, fontFamily: 'Roboto' }}>{decrypt(items.myid.first)} {decrypt(items.myid.second)}</text>
                </div>

                <div onClick={() => navigate('/Dashboard')} style={{ height: 48, cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{inactive_dashboard_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Dashboard</text>
                    </div>
                </div>


                {!items.mode ? <div onClick={() => navigate('/Vision')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_vision_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My vision</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Goals')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_goal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My goals</text>
                    </div>
                </div>

                <div onClick={() => { setActionName(''); setAction(''); setSteps(''); setShareDate(null); remove_select(); setCompleted(false); setPrivate(false) }} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: '#FFFFFF', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{active_week_plan_icon}</div>
                        <text style={{ color: '#8455F6', marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Weekly Action Plan</text>
                    </div>
                </div>

                {!items.mode ? <div onClick={() => navigate('/Journal')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_journal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Journal</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/ActivityPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_activityplan_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Activity Plan</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Wins')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_win_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My Wins</text>
                    </div>
                </div>

                {!items.mode ? <div onClick={() => navigate('/Habit')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_habit_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Habit Tracking</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Videos')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_video_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Videos</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Companies')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{invite_inactive}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Invitations</text>
                    </div>
                </div>

                <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{logout_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Log Out</text>
                    </div>
                </div>

                <div style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                        <text style={{ color: '#8455F6', marginLeft: 20, fontSize: 15, fontFamily: 'Roboto' }}>Coaching Mode</text>
                        <div style={{ width: 45, display: 'flex', marginLeft: 10 }}>
                            <ToggleButton
                                value={items.mode}
                                inactiveLabel={<text></text>}
                                activeLabel={<text></text>}
                                style={{ background_color: '#41A4C3' }}
                                onToggle={(value) => {
                                    SwitchMode()
                                }}
                                colors={{
                                    activeThumb: {
                                        base: 'white',
                                    },
                                    inactiveThumb: {
                                        base: 'black',
                                    },
                                    active: {
                                        base: '#8455f6',
                                        hover: 'rgb(177, 191, 215)',
                                    },
                                    inactive: {
                                        base: 'gray',
                                        hover: 'gray',
                                    }
                                }} />
                        </div>
                    </div>
                </div>

                <img src={logo} style={{ width: 80, height: 80, alignSelf: 'center', marginTop: 20 }} />

            </div>
*/
